import { RootState } from '../../reducers'

export function getExistsExpandedSteps(state: RootState): boolean {
  return state.dialogSteps.expandedSteps.length > 0
}

export function getExpandedDialogsSelector(state: RootState): string[] {
  return state.dialogSteps.expandedSteps
}

export function isExpandedDialogSelector(state: RootState, pathInTree: string): boolean {
  return state.dialogSteps.expandedSteps.includes(pathInTree)
}
